



















import BlueButton from '@/views/atoms/BlueButton.vue'
import GreenButton from '@/views/atoms/GreenButton.vue'
import TextArea from '@/views/atoms/TextArea.vue'
import TextBox from '@/views/atoms/TextBox.vue'

export default
  components: {
    BlueButton
    TextArea
    TextBox
    GreenButton
  }
  props: {
    title:
      type: String
      default: '社内共通'
    type:
      type: String
      default: 'comment'
  }

  methods: {
    save_comment: () ->
      @$emit('save_comment')
    sendMail: () ->
      @$emit('send_mail')
    save_ship_comment: () ->
      @$emit('save_ship_comment')
  }
